export default "__VITE_ASSET__Rq7XW1gp__"